<template lang="pug">
.RoutineFooter
  .left
    .abortButton(
      v-menuClickSound
      v-menuHoverSound
      @click="handleBackButtonClick"
    )
      font-awesome-icon.icon(icon="door-closed")
      | 練習をやめる
  .title
    .main {{title}}
    .sub(v-if="subTitle") {{subTitle}}
  .right
    .soundSettingButton(
      :class="{ 'soundSettingButton--current': soundSettingOpened === true }"
      v-menuHoverSound
      v-menuClickSound
      @click="handleSoundSettingButtonClick"
    )
      font-awesome-icon.icon(icon="volume-up")

  .soundSettingPopup(v-if="soundSettingOpened")
    .title 音の設定
    .toggleSwitch
      .toggleSwitch__on(
        @click="handleMuteSettingSwitchClick('effect', false)"
        :class="{ 'toggleSwitch__on--current': isEffectSoundMuted === false }"
      )
        font-awesome-icon.icon(icon="volume-up")
        | 効果音あり
      .toggleSwitch__off(
        @click="handleMuteSettingSwitchClick('effect', true)"
        :class="{ 'toggleSwitch__off--current': isEffectSoundMuted === true }"
        v-menuHoverSound
      )
        font-awesome-icon.icon(icon="volume-mute")
        | 効果音なし

    .toggleSwitch
      .toggleSwitch__on(
        @click="handleMuteSettingSwitchClick('bgm', false)"
        :class="{ 'toggleSwitch__on--current': isBGMSoundMuted === false }"
      )
        font-awesome-icon.icon(icon="volume-up")
        | BGMあり
      .toggleSwitch__off(
        @click="handleMuteSettingSwitchClick('bgm', true)"
        :class="{ 'toggleSwitch__off--current': isBGMSoundMuted === true }"
        v-menuHoverSound
      )
        font-awesome-icon.icon(icon="volume-mute")
        | BGMなし


</template>

<script>
import { mapState, mapActions } from 'vuex'
import soundService from '@/services/SoundService'
export default {
  name: 'km-routine-footer',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    backPath: {
      type: String,
      default: '/'
    }
  },
  data() {
    return {
      soundSettingOpened: false
    }
  },
  computed: {
    ...mapState('User', {
      isEffectSoundMuted: state => state.isEffectSoundMuted,
      isBGMSoundMuted: state => state.isBGMSoundMuted
    })
  },
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('User', [
      'setEffectSoundMuteStatus',
      'setBGMSoundMuteStatus'
    ]),
    handleMuteSettingSwitchClick(type, isMuted) {
      switch (type) {
        case 'effect':
          this.setEffectSoundMuteStatus(isMuted)
          soundService.setMute('effect', isMuted)
          break
        case 'bgm':
          this.setBGMSoundMuteStatus(isMuted)
          soundService.setMute('bgm', isMuted)
          if (!isMuted) this.playBGM('bgmLesson')
          break
      }
    },
    handleSoundSettingButtonClick() {
      this.soundSettingOpened = !this.soundSettingOpened
    },
    handleBackButtonClick() {
      this.$router.push(this.backPath)
    }
  }
}
</script>

<style lang="scss" scoped>
.RoutineFooter {
  display: flex;
  padding: 0 30px;
  width: 100%;
  height: 80px;
  border-top: 4px solid #000;
  background: rgba(#fff, 1);
  color: #000;
  align-items: center;

  .title {
    flex: 1;
    text-align: center;
    line-height: 1;

    .main {
      font-size: 2.5rem;
    }

    .sub {
      margin: 10px 0 0 0;
      font-size: 1.6rem;
    }
  }

  .right {
    width: 200px;
    text-align: right;
  }

  .abortButton {
    @include button;
    margin: 0 20px 0 0;
    padding: 10px 20px;
    border: 1px solid rgba(0, 0, 0, 0.5);
    background: transparent;
    color: #000000;
    text-align: center;
    border-radius: 100px;

    &:hover {
      margin: 0;
      padding: 10px 30px;
      background: red;
      color: #fff;
    }

    .icon {
      margin-right: 10px;
    }
  }

  .soundSettingButton {
    display: inline-block;
    padding: 10px;
    transition: none ease 0.5s;
    transition-property: opacity, color;

    &:hover {
      opacity: 0.5;
    }

    &--current {
      color: orange;
    }

    .icon {
      font-size: 2.4rem;
    }
  }

  .soundSettingPopup {
    position: absolute;
    bottom: 70px;
    right: 15px;
    padding: 20px;
    width: 360px;
    height: 200px;
    border: 4px solid #000;
    background: #fff;
    text-align: center;
    border-radius: 10px;

    &::after {
      content: '';
      position: absolute;
      right: 20px;
      bottom: -20px;
      width: 30px;
      height: 20px;

      background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='31' height='21' fill='@{bgColor}' stroke='none'><path d='M0,0 L15,20 L30,0 L0,0 Z'></path></svg>")
        no-repeat;
    }

    .title {
      margin: 0 0 20px 0;
      font-weight: bold;
    }

    .toggleSwitch {
      display: inline-flex;
      margin: 0 10px 20px;
      &__on,
      &__off {
        padding: 10px;
        width: 140px;
        border: 2px solid rgba(0, 0, 0, 0.25);
        color: #000;
        transition: ease 0.5s;
        transition-property: border-color, background, color;

        &--current {
          border-color: #000;
          background: #000;
          color: #fff;
        }
        &:hover {
          border-color: rgba(0, 0, 0, 0.5);
        }
      }
      &__on {
        border-right: 0;
        border-radius: 10px 0 0 10px;
      }
      &__off {
        border-left: 0;
        border-radius: 0 10px 10px 0;
      }
    }

    .icon {
      margin: 0 10px 0 0;
    }
  }
}
</style>
